import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";
import * as newUserSelectors from "../../Store/newUser/NewUserSelector";

export const LoginDetailsPopup = ({ visible, onClose }) => {

  const mobileno = useSelector(newUserSelectors.getMobileNo);
  const role = useSelector(newUserSelectors.getRole);
  const usercode = useSelector(newUserSelectors.getUserCode);
  const loginModalHeader = () => {
    return (
      <div data-testid="login-details-header">
        <div className="font-semibold text-xl pt-2 p-3" style={{ color: "#1D2965" }}>
          User Info
        </div>
      </div>
    );
  };

  return (
    <div className="card flex justify-content-center">
      <Dialog
        className="cockpit-dialog"
        header={loginModalHeader}
        visible={visible}
        modal={true}
        style={{ width: "31rem", height: "23rem" }}
        onHide={onClose}
        draggable={false}
      >
        <div className="p-3">
          <div className="m-0">
            <div className="flex font-light text-lg mt-0 graycolor" data-testid="login-id">
              Login ID:<span className="ml-1 font-semibold text-lg pinkcolor">{usercode}</span>
            </div>
            <div className="flex font-light text-lg mt-3 graycolor" data-testid="role-name">
              Role Name: <span className="ml-1 font-semibold text-lg pinkcolor">{role}</span>
            </div>
            <div className="flex font-light text-lg mt-3 graycolor" data-testid="mobile-no">
              Mobile No:<span className="ml-1 font-semibold text-lg pinkcolor">{mobileno}</span>
            </div>
          </div>
          <div className="font-normal text-base mt-4" style={{ color: "#999999" }} data-testid="remember-text">
          Remember your Login ID for future purposes. You can also view your username other info under the
            <span className="font-normal text-base mt-4 blackcolor">‘Profile Setting’</span> tab.
          </div>
          <div>
            <div className="mt-5">
              <Button label="Done" className="w-28rem h-3rem" style={{ backgroundColor: "#1D2965", borderRadius: "8px" }} onClick={onClose} data-testid="done-button" />
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
